import Papa, { ParseResult } from 'papaparse';
import { useDispatch } from 'react-redux';
import { message } from 'antd';
import { AppDispatch } from '../../../core/data/redux/store';
import { fetchEmployeeSalaryStructures, createEmployeeSalaryStructure } from '../../../core/data/redux/payroll/payrollStructure/payrollStructure/employeeSalaryStructureActions';

export const useEmployeeSalaryCSVImport = (setTableKey: React.Dispatch<React.SetStateAction<number>>, user: any) => {
    const dispatch = useDispatch<AppDispatch>();

    const handleCSVImport = (file: File) => {
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: async function (results: ParseResult<any>) {
                const records = results.data as any[];

                // Group by employee_id
                const employeeGroups: Record<string, any[]> = {};
                for (const row of records) {
                    if (!employeeGroups[row.employee_id]) {
                        employeeGroups[row.employee_id] = [];
                    }
                    employeeGroups[row.employee_id].push(row);
                }

                for (const [employeeId, rows] of Object.entries(employeeGroups)) {
                    const salaryStructure = mapGroupedRowsToSalaryStructure(rows, user);

                    try {
                        const result = await dispatch(createEmployeeSalaryStructure(salaryStructure)).unwrap();
                        if (result) {
                            message.success(`Imported salary structure for Employee ID: ${employeeId}`);
                        }
                    } catch (error) {
                        console.error('Error importing salary structure:', error);
                        message.error(`Failed to import for Employee ID: ${employeeId}`);
                    }
                }

                await dispatch(fetchEmployeeSalaryStructures());
                setTableKey((prev) => prev + 1);
            }
        });
    };

    const mapGroupedRowsToSalaryStructure = (rows: any[], user: any) => {
        const firstRow = rows[0];

        const earnings = rows
            .filter(r => r.earning_id && r.earning_name)
            .map(r => ({
                earning_name: r.earning_name,
                amount: parseFloat(r.earning_amount),
                id: r.earning_id,
                earning_id: r.earning_id,
                percent: r.earning_percent !== '' && r.earning_percent !== undefined ? Number(r.earning_percent) : null,
                CreatedBy: user.UserId
            }));

        const deductions = rows
            .filter(r => r.deduction_id && r.deduction_name)
            .map(r => ({
                deduction_name: r.deduction_name,
                amount: parseFloat(r.deduction_amount),
                id: r.deduction_id,
                deduction_id: r.deduction_id,
                percent: r.deduction_percent !== '' && r.deduction_percent !== undefined ? Number(r.deduction_percent) : null,
                CreatedBy: user.UserId
            }));

        return {
            employee_id: firstRow.employee_id,
            pay_scale_id: firstRow.pay_scale_id,
            net_salary: parseFloat(firstRow.net_salary),
            start_date: firstRow.start_date,
            end_date: firstRow.end_date,
            overtime_pay_id: firstRow.overtime_pay_id || null,
            status: 'active',
            CreatedBy: user.UserId,
            earnings,
            deductions
        };
    };

    return {
        handleCSVImport
    };
};
